import React from 'react';

interface PersonOptionLabelProps {
  name: string;
  licenseNumber?: string;
}

/**
 * Renders a person Select option: the name, with their license number on a
 * second, muted, truncated line when one is present. Shared by the Applicators
 * (`SelectApplicator`) and "Authorized by" (`AuthorizedBySelect`) dropdowns.
 */
const PersonOptionLabel: React.FC<PersonOptionLabelProps> = ({
  name,
  licenseNumber
}) => (
  <div style={{ display: 'grid' }}>
    <div>{name}</div>
    {licenseNumber && (
      <div
        className="truncate text-neutral-60 text-xs font-normal leading-5"
        style={{ letterSpacing: '-0.09px' }}
      >
        {`License: ${licenseNumber}`}
      </div>
    )}
  </div>
);

export default PersonOptionLabel;
